import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corona-consent-dialog',
  templateUrl: './corona-consent-dialog.component.html',
  styleUrls: ['./corona-consent-dialog.component.scss']
})
export class CoronaConsentDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
